import React, {Component} from 'react';
import * as Yup from 'yup';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import {FormField} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import {RouteComponentProps} from "react-router";
import {inject, observer} from "mobx-react";
import {Button, Typography} from "@material-ui/core";
import AlertDialog from "../../components/Dialog/alertDialog";
import {IMenuStore} from "../../mobx-store/storeInterfaces/menuStoreInterface";
import {convertDataURLToFile} from "../../mobx-store/stores/menuStore";
import {firebaseStorage} from "../../helperFunctions/firebaseStore";


interface IProps {
    menuStore: IMenuStore;
}

interface IState {
    formFields: FormField[];
    processing: boolean;
    loading: boolean;
    isDialogOpen: boolean;
}

@inject('menuStore')
@observer
class AddEditItem extends Component<IProps & RouteComponentProps<{
    itemId: string
}>, IState> {
    isNew: boolean = false;
    submitButton: any;
    cancelButton: any;
    TeamSchema: any;
    itemId: any;
    pageTitle = '';

    constructor(props: IProps & RouteComponentProps<{
        itemId: string
    }>) {
        super(props);
        if (this.props.match.params.itemId) {
            this.isNew = false;
            this.itemId = this.props.match.params.itemId;
            this.pageTitle = 'Edit Item';
        } else {
            this.isNew = true;
            this.pageTitle = 'Add Item';
        }
        this.initTeamSchema();
        this.initState();
        this.submitButton = this.getSubmitButton();
        this.cancelButton = this.getCancelButton();
    }

    initTeamSchema = () => {
        this.TeamSchema = Yup.object().shape({
            name: Yup.string().required('Required'),
            image: Yup.array()
                .min(1, 'You need to Add at Least one image')
                .max(1, 'You only need to Add one Image')
                .required('Required'),
            images: Yup.array()
                .min(1, 'You need to Add at Least one image')
                .required('Required'),
            description: Yup.string().required('Required'),
            price: Yup.string().required('Required'),
            quantity: Yup.string().required('Required'),
            categoryId: Yup.string().required('Required'),
            brandId: Yup.string().required('Required'),
        });
    };

    getSubmitButton = () => {
        return {
            title: (this.isNew ? 'Add' : 'Save Changes'),
            onSubmit: this.handelSubmit,
        };
    };

    getCancelButton = () => {
        return {
            title: 'Cancel',
            onCancel: this.navigateBack,
        };
    };

    navigateBack = () => {
        this.props.history.goBack();
    };

    handelSubmit = async (values: any) => {
        this.setState({processing: true});
        if (this.isNew) {
            await this.props.menuStore.addItem(values);
        } else {
            await this.props.menuStore.editItem(this.itemId, values);
        }
        this.navigateBack();
        this.setState({processing: false});
    };
    initState = () => {
        this.state = {
            isDialogOpen: false,
            processing: false,
            loading: false,
            formFields: [
                {
                    name: 'name',
                    label: 'Item Name',
                    type: 'text',
                    filedType: 'InputField',
                },
                {
                    name: 'image',
                    label: 'Item Image',
                    filedType: 'GalleryField',
                    value: [],
                    accept: 'png',
                    isLimitToOneImage: true,
                },
                {
                    name: 'images',
                    label: 'Item Images',
                    filedType: 'GalleryField',
                    value: [],
                    accept: 'png',
                },
                {
                    name: 'description',
                    label: 'Item Description',
                    type: 'text',
                    filedType: 'InputField',
                },
                {
                    name: 'price',
                    label: 'Item Price',
                    type: 'number',
                    filedType: 'InputField',
                },
                {
                    name: 'quantity',
                    label: 'Item Quantity',
                    type: 'number',
                    filedType: 'InputField',
                },
                {
                    name: 'categoryId',
                    label: 'Category',
                    selectListKey: 'categoryId',
                    selectListValue: 'categoryName',
                    filedType: 'DropdownField',
                },
                {
                    name: 'brandId',
                    label: 'Brand',
                    selectListKey: 'brandId',
                    selectListValue: 'brandName',
                    filedType: 'DropdownField',
                },
                {
                    name: 'discount',
                    label: 'Item Discount',
                    type: 'number',
                    filedType: 'InputField',
                },
            ]
        };
    };
    updateStateWithTeamData = async (currentItem: any) => {
        const formFieldsWithData = [];
        for (let field of this.state.formFields) {
            if (field.name === 'image') {
                currentItem[field.name] = [{imageUrl: currentItem[field.name]}];
            }
            if (field.name === 'images') {
                const processImages = () => Promise.all(currentItem[field.name].map((imageUrl: any) => {
                    return new Promise(async resolve => {
                        const imageFile = await convertDataURLToFile(imageUrl);
                        resolve(Object.assign(imageFile, {
                            preview: URL.createObjectURL(imageFile),
                        }));
                    });
                }));
                currentItem[field.name] = await processImages();
            }
            formFieldsWithData.push(Object.assign({}, field, {value: currentItem[field.name]}));
        }
        this.setState({formFields: formFieldsWithData, processing: false, loading: false});
    };

    async componentDidMount() {
        this.props.menuStore.mapCategoriesItemsBrands();
        if (!this.isNew) {
            this.setState({loading: true});
            await this.props.menuStore.getItemById(this.itemId).then(snapshot => {
                this.updateStateWithTeamData(snapshot.val());
            }).catch(() => {
                this.setState({loading: false});
            });

        }
    }

    handleDelete = async () => {
        this.setState({isDialogOpen: true});
    };
    handleAgree = async () => {
        await this.props.menuStore.deleteItem(this.itemId);
        this.navigateBack();
    };
    handleClose = () => {
        this.setState({isDialogOpen: false});
    };

    render() {
        const {loaded, brands, categories} = this.props.menuStore;
        if (loaded) {
            const formFields = this.state.formFields.map(field => {
                if (field.name === 'brandId') {
                    return {...field, selectList: brands}
                } else if (field.name === 'categoryId') {
                    return {...field, selectList: categories}
                } else {
                    return field;
                }
            });
            return (
                <div>
                    {this.state.loading ?
                        <Typography variant='h6' gutterBottom>Loading</Typography>
                        : <GeneralFormComponent
                            formTitle={this.pageTitle}
                            fields={formFields}
                            formSchema={this.TeamSchema}
                            submitButton={this.submitButton}
                            cancelButton={this.cancelButton}
                            processing={this.state.processing}
                        />
                    }
                    {/*{*/}
                    {/*    this.isNew ? null : <Button*/}
                    {/*        onClick={this.handleDelete}*/}
                    {/*        variant='contained'*/}
                    {/*        type='button'*/}
                    {/*        style={{fontSize: '14px', fontWeight: 'bold'}}*/}
                    {/*        color='secondary'>*/}
                    {/*        Delete*/}
                    {/*    </Button>*/}
                    {/*}*/}
                    {
                        <AlertDialog isOpen={this.state.isDialogOpen}
                                     title='Delete Item'
                                     content='Are You Sure You want to Delete This Item ?'
                                     buttonText='ok'
                                     agree={this.handleAgree}
                                     disAgree={this.handleClose}
                                     hasActions={true}
                        />
                    }
                </div>
            );
        } else
            return null;
    }
}

export default AddEditItem;